import type { CategoryContent } from '../../row.js';

/** Natuurkunde, chemie en biologie, tweede deel. Correcte optie eerst; wordt bij build geroteerd. */

export const MORE_PHYSICS: CategoryContent = {
  msc: [
    [
      'Wat verbetert het Debye-model ten opzichte van het model van Einstein voor warmtecapaciteit?',
      [
        'Het behandelt roostertrillingen als een spectrum van modes',
        'Het neemt de elektronische bijdrage aan warmtecapaciteit bij lage temperatuur mee',
        'Het corrigeert voor anharmonische effecten bij hoge temperatuur',
        'Het behandelt elk atoom als een onafhankelijke oscillator bij één enkele frequentie',
      ],
      0,
      'De behandeling met één frequentie is die van Einstein, en die valt exponentieel af waar experimenten een machtswet laten zien.',
    ],
    [
      'De Schwarzschild-straal van een massa M is evenredig met wat?',
      ['M', 'M in het kwadraat', 'De wortel van M', 'De logaritme van M'],
      0,
      '2GM/c-kwadraat, dus lineaire schaling - waarom een superzwaar zwart gat zulke lage getijdenkrachten heeft bij zijn horizon.',
    ],
    [
      'Wat relateert de fluctuatie-dissipatiestelling aan elkaar?',
      [
        'Spontane fluctuaties in een systeem in evenwicht aan zijn lineaire respons op verstoring',
        'De entropie van een systeem aan de logaritme van zijn toegankelijke microtoestanden',
        'Warmtestroom aan de temperatuurgradiënt in een geleidend medium',
        'De druk van een gas aan de gemiddelde kwadratische snelheid van zijn moleculen',
      ],
      0,
      'Johnson-ruis in een weerstand is het schoolboekvoorbeeld: de ruis en de weerstand zijn dezelfde fysica, twee keer bekeken.',
    ],
    [
      'In de speciale relativiteitstheorie, welke grootheid is invariant tussen inertiaalstelsels?',
      [
        'Het ruimtetijdinterval',
        'De tijd tussen twee gebeurtenissen',
        'De ruimtelijke afstand tussen twee gebeurtenissen',
        'De totale impuls van een geïsoleerd systeem',
      ],
      0,
      'Impuls is behouden binnen een stelsel, maar niet invariant tussen stelsels. Het interval vervangt de losse invariantie van ruimte en tijd.',
    ],
    [
      'Wat is de betekenis van de Fermi-energie in een metaal?',
      [
        'Het hoogst bezette elektronenenergieniveau bij nul kelvin, dat de meeste elektronische eigenschappen bepaalt',
        'De energie die nodig is om een elektron volledig uit het metaal te verwijderen',
        'De gemiddelde thermische energie van geleidingselektronen bij kamertemperatuur',
        'De energiekloof tussen valentie- en geleidingsband, die bepaalt of een vaste stof überhaupt geleidt',
      ],
      0,
      'Het volledig verwijderen van het elektron is de werkfunctie. Alleen elektronen binnen ongeveer kT van het Fermi-niveau doen mee aan geleiding, wat verklaart waarom klassieke voorspellingen voor warmtecapaciteit zo faalden.',
    ],
    [
      'De wet van Stefan-Boltzmann stelt dat uitgestraald vermogen schaalt met welke macht van temperatuur?',
      ['De vierde', 'De tweede', 'De derde', 'De eerste'],
      0,
      'Vandaar dat een bescheiden temperatuurstijging zo\'n groot verschil maakt voor stralingskoeling, en waarom klimaatterugkoppelingsanalyse daar begint.',
    ],
    [
      'Wat specificeert het tripelpunt van een fasediagram?',
      [
        'De unieke omstandigheden waarbij vast, vloeibaar en damp in evenwicht naast elkaar bestaan',
        'De omstandigheden waarboven vloeibaar en damp niet meer te onderscheiden zijn',
        'De druk waarbij een vaste stof direct sublimeert naar damp',
        'De temperatuur waarbij de warmtecapaciteit van een stof divergeert',
      ],
      0,
      'Het punt waar vloeibaar en damp niet meer te onderscheiden zijn is het kritische punt. Het tripelpunt van water definieerde de kelvin tot de herdefinitie van 2019.',
    ],
    [
      'De Hubble-parameter heeft de dimensie van wat?',
      [
        'Inverse tijd',
        'Snelheid',
        'Versnelling',
        'Inverse lengte',
      ],
      0,
      'Vandaar dat de inverse ervan een ruwe leeftijd van het heelal geeft, en waarom km/s/Mpc een eenheid is die zijn eigen dimensies verstopt.',
    ],
    [
      'Wat is de fysische inhoud van de stelling van Noether?',
      [
        'Elke continue symmetrie van de actie hoort bij een behouden grootheid',
        'Elke behouden grootheid impliceert een onderliggende discrete symmetrie',
        'Symmetrieën van een hamiltoniaan commuteren met de tijdsevolutie-operator',
        'Elke lagrangiaan kan geschreven worden in een vorm die invariant is onder coördinatentransformatie',
      ],
      0,
      'Tijdstranslatie geeft energie, ruimtelijke translatie impuls, rotatie impulsmoment. Daarom zijn behoudswetten geen toevalligheden.',
    ],
    [
      'Waar verwijst de term "degeneratiedruk" naar?',
      [
        'Druk die ontstaat door het Pauli-uitsluitingsprincipe',
        'Stralingsdruk van fotonen die opgesloten zitten in een sterinterieur',
        'Druk van relativistische elektronen die de lichtsnelheid naderen',
        'Druk uitgeoefend door neutrino\'s die ontsnappen aan een instortende kern',
      ],
      0,
      'Dit ondersteunt witte dwergen en neutronensterren, en de temperatuuronafhankelijkheid ervan is precies waarom ze zichzelf niet kunnen reguleren zoals een ster op de hoofdreeks dat kan.',
    ],
  ],
  phd: [
    [
      'Wat levert spontane symmetriebreking op in het Standaardmodel?',
      [
        'Massa\'s voor de zwakke gaugebosonen en fermionen zonder gauge-invariantie te schenden',
        'De loop van de koppelingsconstanten met de energieschaal',
        'Opsluiting van kleurlading bij lage energieën',
        'De annulering van chirale anomalieën tussen generaties',
      ],
      0,
      'Een met de hand ingevoerde massaterm zou gauge-invariantie schenden; het Higgs-mechanisme levert hetzelfde resultaat terwijl het die behoudt.',
    ],
    [
      'Wat is de fysische betekenis van de renormalisatiegroep?',
      [
        'Hoe effectieve koppelingen veranderen met de schaal waarop een theorie wordt onderzocht',
        'Een procedure om oneindigheden te verwijderen door divergente integralen weg te laten',
        'De eis dat alle waarneembare grootheden invariant zijn onder gaugetransformaties',
        'Een methode om storingsreeksen tot alle ordes te sommeren',
      ],
      0,
      'Wilsons herformulering maakte van renormalisatie geen aftrektrucje meer, maar een uitspraak over welke vrijheidsgraden op welke schaal ertoe doen.',
    ],
    [
      'Waar sluiten de Bell-ongelijkheden, wanneer experimenteel geschonden, iets uit?',
      [
        'Lokale verborgen-variabelentheorieën die kwantumvoorspellingen reproduceren',
        'Elke interpretatie van de kwantummechanica met verborgen variabelen',
        'De mogelijkheid van sneller-dan-lichtsignalering',
        'De volledigheid van de kwantumtoestandsbeschrijving',
      ],
      0,
      'Niet-lokale verborgen variabelen - de bohmiaanse mechanica - overleven dit. Het onderscheid tussen lokale en willekeurige verborgen variabelen is waar populaire uitleg meestal misgaat.',
    ],
    [
      'Wat doet de Landau-theorie van faseovergangen?',
      [
        'Ze ontwikkelt de vrije energie in machten van een orde-parameter om overgangen naar symmetrie te classificeren',
        'Ze berekent kritische exponenten exact in drie dimensies',
        'Ze leidt overgangstemperaturen af uit microscopische interactiepotentialen',
        'Ze behandelt fluctuaties exact nabij het kritische punt',
      ],
      0,
      'Het is een meanfield-benadering en krijgt daarom de exponenten fout nabij kriticaliteit - precies wat de renormalisatiegroep moest oplossen.',
    ],
    [
      'Wat is de Eddington-limiet?',
      [
        'De lichtkracht waarbij stralingsdruk zwaartekracht in evenwicht houdt, wat stabiele accretie begrenst',
        'De maximale massa die een ster kan hebben voordat de kern instort, bepaald door elektronendegeneratiedruk',
        'De maximale rotatiesnelheid voordat een ster onstabiel wordt',
        'De begrenzende temperatuur van de binnenrand van een accretieschijf',
      ],
      0,
      'Daarom heeft de groei van superzware zwarte gaten een natuurlijke tijdschaal, en daarom is super-Eddington-accretie zo\'n interessant probleem.',
    ],
    [
      'Wat veronderstelt de WKB-benadering?',
      [
        'De potentiaal verandert langzaam vergeleken met de lokale de-Broglie-golflengte',
        'De verstoring is klein vergeleken met de ongestoorde hamiltoniaan',
        'Het systeem blijft dicht bij zijn grondtoestand',
        'De golffunctie kan ontwikkeld worden in een compleet stelsel van vlakke golven',
      ],
      0,
      'Ze faalt precies bij keerpunten, waarom asymptotische aansluiting en de Airy-functie in elke behandeling ervan opduiken.',
    ],
    [
      'Wat is de betekenis van de akoestische pieken van de kosmische microgolfachtergrond?',
      [
        'Hun posities en hoogtes begrenzen samen kromming, baryondichtheid en donkere-materiedichtheid',
        'Ze registreren het tijdperk van reïonisatie door de eerste sterren',
        'Ze ontstaan door zwaartekrachtlensing door tussenliggende structuur',
        'Ze meten de eigen snelheid van de Lokale Groep, die als dipool verschijnt in de temperatuurkaart',
      ],
      0,
      'De hoekpositie van de eerste piek is de geometrische liniaal; de verhouding tussen even en oneven pieken is wat de baryonen vastlegt.',
    ],
    [
      'Wat kenmerkt een topologische isolator in de gecondenseerde materie?',
      [
        'Een isolerende bulk met geleidende oppervlaktetoestanden die beschermd worden door topologie en tijdsomkeersymmetrie',
        'Een geleidende bulk met isolerende randen bij lage temperatuur',
        'Een materiaal waarvan de resistiviteit exact gekwantiseerd is in de bulk, onafhankelijk van monstergeometrie of wanorde',
        'Een supraleider waarvan de bandkloof sluit op geïsoleerde punten in de impulsruimte',
      ],
      0,
      'De bescherming is wat ze interessant maakt: de oppervlaktegeleiding overleeft wanorde die een gewone oppervlaktetoestand zou lokaliseren.',
    ],
    [
      'Wat meet het Sunyaev-Zel\'dovich-effect?',
      [
        'Vervorming van het CMB-spectrum door inverse Compton-verstrooiing aan hete clusterelektronen',
        'De roodverschuiving van clustersterrenstelsels ten opzichte van de CMB-dipool',
        'Gravitationele roodverschuiving van fotonen die aan een clusterpotentiaal ontsnappen',
        'Absorptie van CMB-fotonen door tussenliggend neutraal waterstof',
      ],
      0,
      'De onafhankelijkheid van roodverschuiving is het nuttige deel: clusters kunnen ermee gevonden worden op afstanden waar ze optisch te zwak zijn om te zien.',
    ],
    [
      'Welk probleem lost inflatie op, en welk niet?',
      [
        'Ze pakt het horizon- en vlakheidsprobleem aan, maar verklaart niet zelf de begincondities die ze veronderstelt',
        'Ze verklaart de baryonasymmetrie, maar niet de vlakheid van de ruimte',
        'Ze verklaart donkere energie, maar niet de oorsprong van structuur',
        'Ze lost de singulariteit bij de oerknal volledig op, en vervangt deze door een eeuwig inflaterende voorafgaande expansiefase',
      ],
      0,
      'Het maatprobleem en de vraag naar begincondities zijn waarom de lezing "inflatie verklaart alles" weerstand krijgt binnen de kosmologie.',
    ],
  ],
  professor: [
    [
      'Wat is de informatieparadox van zwarte gaten, precies gesteld?',
      [
        'Hawkingstraling lijkt thermisch',
        'De singulariteit vernietigt informatie voordat ze uitgestraald kan worden',
        'Geen waarnemer kan de innerlijke toestand meten, dus informatie is ongedefinieerd',
        'De entropie van de horizon overschrijdt de entropie van de instortende materie',
      ],
      0,
      'De Page-curve is de aangescherpte versie, en de recente berekeningen met "eilanden" zijn wat vooruitgang mogelijk maakte.',
    ],
    [
      'Wat stelt de AdS/CFT-correspondentie?',
      [
        'Een gravitatietheorie in anti-de-Sitter-ruimte is duaal aan een conforme veldtheorie op zijn rand',
        'Elke kwantumveldtheorie heeft een gravitationele duale in één dimensie hoger',
        'Snaartheorie in vlakke ruimte is equivalent aan een gaugetheorie bij sterke koppeling',
        'De entropie van een zwart gat is gelijk aan de verstrengelingsentropie van het vacuüm',
      ],
      0,
      'Maldacena, 1997. De veralgemening naar elke veldtheorie is precies wat niet is vastgesteld, en ons heelal is geen anti-de-Sitter-ruimte.',
    ],
    [
      'Wat voorspelt Kibble-Zurek-schaling voor een langzame quench?',
      [
        'De defectdichtheid daalt als een macht van de quenchsnelheid',
        'De defectdichtheid is onafhankelijk van de quenchsnelheid onder een drempel',
        'Defecten verdwijnen volledig als de quench langzamer is dan de relaxatietijd',
        'De defectdichtheid schaalt exponentieel met de correlatielengte',
      ],
      0,
      'Het is nu getest in koude atomen, ionenkettingen en supervloeistoffen, meer dan de kosmologische toepassing waarvoor het bedacht werd kan bieden.',
    ],
    [
      'Wat is het sterke-CP-probleem?',
      [
        'QCD staat een CP-schendende term toe waarvan de coëfficiënt buitengewoon klein gemeten is, zonder verklaring',
        'CP-schending in de zwakke sector is te klein om baryogenese te verklaren',
        'De sterke koppelingsconstante divergeert bij lage energieën, waardoor storingstheorie helemaal faalt in het opsluitingsregime',
        'Quarkmassa\'s kunnen door geen enkele chirale rotatie reëel gemaakt worden',
      ],
      0,
      'De theta-term. De Peccei-Quinn-oplossing is waar het axion vandaan komt, en dat is precies waarom het tegelijk een kandidaat voor donkere materie is.',
    ],
    [
      'Wat beschrijft de Hawking-Page-overgang?',
      [
        'Een eerste-orde-overgang tussen thermisch AdS en een groot zwart gat bij stijgende temperatuur',
        'Het eindpunt van verdamping waarbij een zwart gat een restant wordt',
        'De overgang van een stralingsgedomineerd naar een materiegedomineerd heelal',
        'Het begin van superradiantie in een roterend zwart gat',
      ],
      0,
      'In het holografische woordenboek komt dit overeen met opsluiting-deopsluiting in de randtheorie, en dat is een groot deel van waarom het ertoe doet.',
    ],
    [
      'Waardoor wordt de gekwantiseerde geleiding van het quantum-Hall-effect verklaard?',
      [
        'Een topologische invariant, het Chern-getal, van de gevulde Landau-banden',
        'De exacte annulering van verstrooiing aan onzuiverheden bij lage temperatuur',
        'De vorming van een Wigner-kristal in het tweedimensionale elektronengas',
        'Fluxkwantisatie in de supraleidende contacten van het apparaat',
      ],
      0,
      'TKNN, 1982. De precisie ervan is waarom het nu de weerstandsstandaard onderbouwt - een topologisch argument in een metrologielaboratorium.',
    ],
    [
      'Wat is het probleem van de kosmologische constante?',
      [
        'Veldtheoretische schattingen van vacuümenergie overschrijden de waargenomen waarde met vele tientallen ordes van grootte',
        'De waargenomen expansiesnelheid is inconsistent met een constante vacuümenergie',
        'Donkere energie is observationeel niet te onderscheiden van aangepaste zwaartekracht',
        'De constante is niet invariant onder algemene coördinatentransformaties, waardoor zijn waarde afhankelijk is van het gekozen stelsel',
      ],
      0,
      'De slechtste kwantitatieve voorspelling in de natuurkunde, volgens sommige tellingen. Antropische en landschapsargumenten zijn wat overblijft bij gebrek aan een mechanisme.',
    ],
    [
      'Wat levert het Sachdev-Ye-Kitaev-model op?',
      [
        'Een oplosbaar sterk gekoppeld model met maximale chaos, verbonden met holografie en de dynamica van zwarte gaten',
        'Een exacte oplossing van het driedimensionale Ising-model, waaruit de kritische exponenten direct volgen',
        'Een hanteerbaar roostermodel van hogetemperatuursupraleiding',
        'Een afleiding van de fermivloeistoftheorie vanuit eerste beginselen',
      ],
      0,
      'Het verzadigen van de chaosgrens is wat het aan de zwaartekracht verbindt, en oplosbaar zijn is wat het nuttig maakt.',
    ],
    [
      'Wat is de huidige status van de Hubble-spanning?',
      [
        'Lokale afstandsladder- en CMB-afgeleide expansiesnelheden verschillen buiten de opgegeven onzekerheden, zonder geaccepteerde oplossing',
        'De spanning werd opgelost door herziene Cepheïde-calibratie',
        'Ze ontstaat volledig door een ongemodelleerde lokale holte, waardoor de lokale meting correct is maar simpelweg niet representatief voor de globale snelheid',
        'Ze verdwijnt wanneer supernovamonsters beperkt worden tot lage roodverschuiving',
      ],
      0,
      'Of het systematiek of nieuwe fysica is, is precies wat onopgelost is, en JWST-calibratie heeft de systematiekverklaring versmald zonder hem te sluiten.',
    ],
    [
      'Wat stelt "eigenstate thermalization" voor?',
      [
        'Individuele, sterk aangeslagen eigentoestanden van een veeldeeltjessysteem coderen al thermische verwachtingswaarden',
        'Thermalisatie vereist in alle gevallen koppeling aan een extern bad, waardoor een geïsoleerd systeem nooit kan thermaliseren',
        'Geïsoleerde kwantumsystemen kunnen niet thermaliseren omdat evolutie unitair is',
        'Thermisch gedrag ontstaat alleen na middeling over begintoestanden',
      ],
      0,
      'Dit verenigt unitaire microscopische evolutie met thermisch macroscopisch gedrag, en many-body-localisatie is de interessante uitzondering hierop.',
    ],
  ],
};

export const MORE_CHEMISTRY: CategoryContent = {
  msc: [
    [
      'Wat voorspelt het principe van Le Chatelier voor een evenwicht onder verhoogde druk?',
      [
        'Een verschuiving naar de kant met minder mol gas',
        'Een verschuiving naar de kant met meer mol gas',
        'Een toename van de evenwichtsconstante',
        'Geen verandering, omdat druk evenwichten niet beïnvloedt',
      ],
      0,
      'De constante zelf verandert niet met druk - alleen de positie doet dat, en dat onderscheid maakt het principe meestal te los geformuleerd.',
    ],
    [
      'Wat is een Grignard-reagens, en wat verdraagt het niet?',
      [
        'Een organomagnesiumhalide, onverenigbaar met protische oplosmiddelen en zure waterstoffen',
        'Een organolithiumverbinding, alleen onverenigbaar met water',
        'Een organozinkverbinding, verenigbaar met alcoholen en aminen',
        'Een organokoperverbinding, onverenigbaar met ethersolventen en onreactief tegenover ketonen',
      ],
      0,
      'Zijn basiciteit is de beperking: elk zuur proton doodt het, en dat is waarom de substraatbreedte veel smaller is dan de reactie doet vermoeden.',
    ],
    [
      'Wat relateert de wet van Beer-Lambert aan elkaar?',
      [
        'Absorbantie aan concentratie, weglengte en molaire extinctiecoëfficiënt',
        'Fluorescentie-intensiteit aan excitatiegolflengte',
        'Brekingsindex aan opgeloste-stofconcentratie',
        'Verstrooiingsintensiteit aan deeltjesradius',
      ],
      0,
      'De wet faalt bij hoge concentratie waar de aanname van niet-interagerende absorbeerders wegvalt, wat verklaart waarom calibratiecurves afvlakken.',
    ],
    [
      'Wat is de entropieverandering wanneer een ideaal gas isotherm uitzet in een vacuüm?',
      [
        'Positief, omdat het toegankelijke volume toeneemt',
        'Nul, omdat de temperatuur onveranderd blijft',
        'Negatief, omdat er geen arbeid op de omgeving wordt verricht',
        'Nul, omdat het proces adiabatisch is',
      ],
      0,
      'nR ln(V2/V1). Vrije expansie is irreversibel, wat precies verklaart waarom de entropie stijgt zonder warmteoverdracht.',
    ],
    [
      'Wat is een chiraal centrum?',
      [
        'Een atoom met substituenten die zo geschikt zijn dat het molecuul niet op zijn spiegelbeeld te leggen is',
        'Elk koolstofatoom gebonden aan vier verschillende atomen van hetzelfde element',
        'Een dubbele binding die rotatie verhindert en tot afzonderlijke isomeren leidt',
        'Een ringverbinding waar twee ringen twee atomen delen, wat de relatieve geometrie van beide vastlegt',
      ],
      0,
      'Het geval met de dubbele binding is geometrische isomerie, wat andere verbindingen oplevert, maar geen enantiomeren.',
    ],
    [
      'Wat zegt een meting van de zèta-potentiaal over een colloïde?',
      [
        'De elektrostatische potentiaal op het schuifvlak, een indicatie van suspensiestabiliteit',
        'De gemiddelde hydrodynamische straal van de gedispergeerde deeltjes',
        'De oppervlaktespanning tussen de gedispergeerde en de continue fase',
        'De viscositeit van de continue fase bij het deeltjesoppervlak',
      ],
      0,
      'Waarden boven ongeveer dertig millivolt, in beide richtingen, betekenen doorgaans dat de suspensie samenklontering weerstaat.',
    ],
    [
      'Wat is het verschil tussen een syn- en een anti-additie?',
      [
        'Of beide nieuwe bindingen aan hetzelfde vlak van het substraat ontstaan of aan tegenoverliggende vlakken',
        'Of de reactie via een radicaal of een ionisch mechanisme verloopt',
        'Of de reactie onder kinetische of thermodynamische controle staat',
        'Of het product racemisch of enantiomeer verrijkt is',
      ],
      0,
      'Osmiumtetroxide-dihydroxylering is syn; broomadditie via een broomonium-ion is anti - en de stereochemie is hoe je het mechanisme herkent.',
    ],
    [
      'Wat is een gemeenschappelijk-ioneffect?',
      [
        'Verminderde oplosbaarheid van een zout wanneer een oplossing al een van zijn ionen bevat',
        'Verhoogde oplosbaarheid van een zout in aanwezigheid van een complexerend middel',
        'De neiging van ionen met vergelijkbare straal om in een rooster te substitueren',
        'De gelijke migratiesnelheid van ionen met dezelfde lading in een veld',
      ],
      0,
      'Een directe toepassing van Le Chatelier op een oplosbaarheidsproduct, en de basis van de meeste gravimetrische precipitatieprocedures.',
    ],
    [
      'Wat suggereert een M+2-piek in een massaspectrum met ongeveer gelijke intensiteit als M+?',
      [
        'De aanwezigheid van een broomatoom',
        'De aanwezigheid van een chlooratoom',
        'De aanwezigheid van twee stikstofatomen',
        'Een dubbel geladen moleculair ion',
      ],
      0,
      'De isotopen van broom liggen dicht bij 1:1; chloor geeft ongeveer 3:1, het paar dat je leert op zicht te herkennen.',
    ],
    [
      'Wat is het doel van een Büchner-trechter met een waterstraalpomp?',
      [
        'Filtratie onder verlaagde druk, om een vaste stof snel van een oplosmiddel te scheiden',
        'Fractionele destillatie van een mengsel bij verlaagde druk',
        'Continue extractie van een opgeloste stof tussen niet-mengbare fasen',
        'Sublimatie van een vluchtige vaste stof op een gekoeld oppervlak',
      ],
      0,
      'Alledaags en overal. De val tussen trechter en pomp bestaat omdat terugzuiging in je product de klassieke ramp van het eerste jaar is.',
    ],
  ],
  phd: [
    [
      'Wat onthult een Hammett-plot?',
      [
        'Hoe elektronische substituenteffecten snelheid of evenwicht veranderen',
        'De orde van een reactie ten opzichte van elke reactant',
        'De activeringsentropie uit de temperatuurafhankelijkheid van de snelheid',
        'De omvang van conjugatie uit de verschuiving van het absorptiemaximum',
      ],
      0,
      'Een negatieve rho betekent dat positieve lading opbouwt. Een knik in de plot betekent meestal dat het mechanisme verandert over het substituentbereik.',
    ],
    [
      'Wat is de betekenis van een kinetisch isotoopeffect van 6-7 voor C-H versus C-D?',
      [
        'De binding wordt verbroken in de snelheidsbepalende stap, een primair effect nabij het semiklassieke maximum',
        'Het isotoop is aanwezig, maar niet betrokken bij de snelheidsbepalende stap',
        'De reactie verloopt via een radicaalkettingmechanisme, waarbij het isotoop de propagatie beïnvloedt in plaats van de initiatie',
        'Tunneling domineert de reactie op alle temperaturen',
      ],
      0,
      'Waarden ver boven ongeveer 7 zijn de gebruikelijke signatuur van tunneling, wat verklaart waarom ze aandacht trekken bij enzymmechanismen.',
    ],
    [
      'Wat verklaart de 18-elektronregel, en waar faalt ze?',
      [
        'Stabiliteit van organometaalcomplexen',
        'Stabiliteit van hypervalente hoofdgroepverbindingen, faalt voor periode twee',
        'Coördinatiegetal in lanthanidecomplexen, faalt voor de actiniden',
        'Bindingsorde in metaal-metaal-meervoudige bindingen, faalt voorbij vierdubbele bindingen',
      ],
      0,
      'Zestien-elektron vierkant-planaire complexen zijn stabiel en veelvoorkomend, wat verklaart waarom oxidatieve-additiechemie überhaupt werkt.',
    ],
    [
      'Wat is een Curtin-Hammett-situatie?',
      [
        'Snel interconverterende conformeren waarvan de productverhouding afhangt van overgangstoestandenergieën, niet van conformeerpopulaties',
        'Twee concurrerende mechanismen met identieke snelheidswetten, waardoor kinetica alleen ze op geen enkele concentratie kan onderscheiden',
        'Een reactie waarvan de selectiviteit volledig bepaald wordt door het stabielere conformeer',
        'Een stapsgewijze reactie waarbij de eerste stap volledig reversibel en snelheidsbepalend is',
      ],
      0,
      'Het meest voorkomende conformeer hoeft niet het hoofdproduct te geven - dit ondermijnt productvoorspellingen die uitgaan van grondtoestandspopulaties.',
    ],
    [
      'Wat beschrijft de Butler-Volmer-vergelijking in de elektrochemie?',
      [
        'Stroomdichtheid als functie van overpotentiaal voor een ladingsoverdracht-gelimiteerde elektrodereactie',
        'De evenwichtspotentiaal van een halfcel uit activiteiten',
        'De diffusiegelimiteerde stroom bij een roterende schijfelektrode',
        'De capaciteit van de elektrische dubbellaag, als functie van elektrolytconcentratie en potentiaal',
      ],
      0,
      'Het diffusiegelimiteerde geval is Levich; bij hoge overpotentiaal reduceert Butler-Volmer tot de Tafel-relatie.',
    ],
    [
      'Wat is de oorsprong van het trans-effect bij vierkant-planaire substitutie?',
      [
        'Een ligand beïnvloedt de labiliteit van de positie trans daarop',
        'Sterische hinder tussen cis-liganden dwingt dissociatie af',
        'Kristalveldstabilisatie is maximaal in de trans-configuratie',
        'Trans-liganden koppelen alleen via de gevulde d-orbitalen van het metaal',
      ],
      0,
      'Het is een kinetisch effect, en de thermodynamische trans-invloed onderscheiden van het kinetische trans-effect is een routinematige bron van verwarring.',
    ],
    [
      'Wat bepaalt een Job-plot?',
      [
        'De bindingsstoichiometrie van een gastheer-gast-complex uit de mol-ratio-afhankelijkheid van een signaal',
        'De associatieconstante uit een verzadigingsbindingscurve',
        'De bindingsenthalpie uit een temperatuurreeks, door de van-\'t-Hoff-relatie op de constanten te fitten',
        'De coöperativiteit van binding uit een Hill-coëfficiënt',
      ],
      0,
      'De positie van het maximum geeft de stoichiometrie. De methode veronderstelt dat er één complex vormt, en misleidt stilletjes wanneer er meerdere vormen.',
    ],
    [
      'Wat onderscheidt chemische dampdepositie van atomaire-laagdepositie?',
      [
        'ALD gebruikt zelfbegrenzende opeenvolgende halfreacties',
        'ALD werkt bij atmosferische druk en CVD onder vacuüm',
        'ALD deponeert alleen metalen en CVD alleen dielectrica',
        'ALD vereist plasma en CVD niet',
      ],
      0,
      'Zelfbegrenzing is wat conformaliteit oplevert in structuren met hoge aspectverhouding, en dat is waarom ALD onmisbaar werd bij kleine knooppunten.',
    ],
    [
      'Wat is de fysische basis van de chemische verschuiving in NMR?',
      [
        'Lokale elektronencirculatie schermt de kern af, wat het effectieve veld dat deze ervaart verandert',
        'Directe dipolaire koppeling tussen naburige kernspins door de tussenliggende ruimte, in plaats van via bindingen',
        'Variatie in de gyromagnetische verhouding tussen chemische omgevingen',
        'Verschillen in de relaxatiesnelheid van kernspins tussen posities',
      ],
      0,
      'Afscherming is waarom verschuiving in ppm wordt gerapporteerd - het effect schaalt met het aangelegde veld, dus de dimensieloze verhouding is het overdraagbare getal.',
    ],
    [
      'Wat toont een Pourbaix-diagram?',
      [
        'Thermodynamisch stabiele soorten als functie van potentiaal en pH',
        'Reactiesnelheid als functie van temperatuur en pH',
        'Fasesamenstelling als functie van temperatuur en druk',
        'Oplosbaarheid als functie van ionaire sterkte en pH',
      ],
      0,
      'Puur thermodynamisch, en dat is waarom passiveringsgebieden erop misleidend kunnen zijn: het diagram zegt niets over hoe snel iets gebeurt.',
    ],
  ],
  professor: [
    [
      'Wat wordt het Curtin-Hammett-principe in de context van dynamische kinetische resolutie?',
      [
        'Snelle substraatracemisering gecombineerd met een enantioselectieve stap kan een racemaat omzetten in één enantiomeer boven de vijftig procent',
        'Een racemaat kan slechts tot vijftig procent opbrengst van elk enantiomeer gescheiden worden',
        'Selectiviteit is vastgelegd door de relatieve stabiliteit van de twee substraatenantiomeren',
        'De omzettingssnelheid van de katalysator moet de racemiseringssnelheid overtreffen voor hoge selectiviteit, anders raakt de substraatpoel ongelijk uitgeput',
      ],
      0,
      'Dit doorbreekt het opbrengstplafond dat gewone resolutie oplegt, en dat is waarom het industrieel belangrijk is, niet alleen conceptueel.',
    ],
    [
      'Wat is het Sabatier-principe in heterogene katalyse?',
      [
        'Optimale activiteit treedt op bij intermediaire bindingssterkte',
        'Activiteit stijgt monotoon met het aantal blootgestelde actieve plaatsen',
        'Selectiviteit en activiteit kunnen niet gelijktijdig geoptimaliseerd worden',
        'De katalytische snelheid is evenredig met de oppervlaktevrije energie van de katalysator',
      ],
      0,
      'Dit levert de vulkaanplot op, en computationele screening van descriptoren zoals bindingsenergie is in essentie geïndustrialiseerd Sabatier-denken.',
    ],
    [
      'Wat voegt de Marcus-Hush-behandeling van elektronoverdracht toe aan een simpel activeringsbeeld?',
      [
        'Reorganisatie-energie van solvent en binnenschil als expliciete parameter naast de drijvende kracht',
        'Een tunnelcorrectie voor waterstofoverdracht, die dominant wordt bij lage temperatuur in enzymen',
        'Expliciete behandeling van de elektrode-dubbellaag',
        'Een statistische behandeling van donor-acceptorafstandsverdelingen',
      ],
      0,
      'Lambda en delta-G samen leveren het inverse gebied op, dat twee decennia kostte om te observeren en de Nobelprijs opleverde toen het lukte.',
    ],
    [
      'Wat is "frustrated Lewis pair"-chemie?',
      [
        'Sterisch verhinderde zuur-baseadducten die reactiviteit behouden en waterstof heterolytisch kunnen splitsen',
        'Lewis-paren waarvan de adductvorming bij alle temperaturen thermodynamisch ongunstig is',
        'Zuur-baseparen op naburige oppervlakteplaatsen van een vaste katalysator',
        'Paren waarvan de reactiviteit een overgangsmetaal als bemiddelaar vereist',
      ],
      0,
      'Het werk van Stephan en Erker. Metaalvrije hydrogenering is de belangrijkste toepassing, en dit herformuleerde sterische frustratie als ontwerpprincipe.',
    ],
    [
      'Wat drukt de Bell-Evans-Polanyi-relatie uit, en wat is de moderne opvolger?',
      [
        'Een lineaire correlatie tussen activerings- en reactie-energieën',
        'Een logaritmische relatie tussen snelheid en evenwichtsconstante voor zuurkatalyse',
        'Een evenredigheid tussen activeringsentropie en -enthalpie over een reactiereeks',
        'Een relatie tussen bindingsdissociatie-energie en vibratiefrequentie',
      ],
      0,
      'Het geval van zuurkatalyse is Bronsted. BEP-relaties maken computationele screening van katalysatoren hanteerbaar, en beperken ook hoe ver dat te trekken is.',
    ],
    [
      'Wat is de essentiële moeilijkheid bij structuurbepaling van enkele moleculen met cryo-EM op atomaire resolutie?',
      [
        'Dosisgelimiteerde signaal-ruisverhouding, die middeling vereist over veel deeltjes in onbekende oriëntaties',
        'Stralingsschade kan niet verminderd worden tot onder het niveau dat secundaire structuur vernietigt',
        'Preparaten kunnen niet gevitrificeerd worden zonder kristallijne ijsvorming',
        'De kwantumefficiëntie van detectoren blijft onder één procent',
      ],
      0,
      'Directe elektronendetectoren en betere classificatiealgoritmen brachten de resolutierevolutie - de dosislimiet zelf verschoof niet.',
    ],
    [
      'Wat verbiedt "behoud van orbitaalsymmetrie" in een concerted cycloadditie?',
      [
        'Een thermische supra-suprafaciale 2+2-cycloadditie',
        'Elke 4+2-cycloadditie onder thermische omstandigheden',
        'Fotochemische 2+2-cycloadditie van alkenen',
        'Elke cheletrope reactie met een tweewaardige soort',
      ],
      0,
      'De 4+2 Diels-Alder is thermisch toegestaan en de 2+2 fotochemisch - de omkering tussen thermisch en fotochemisch is de hele inhoud van de regels.',
    ],
    [
      'Wat is de huidige mechanistische consensus over het zuurstof-ontwikkelend complex van fotosysteem II?',
      [
        'Een Mn4CaO5-cluster die door Kok-S-toestanden cyclt',
        'Een binucleair ijzercentrum dat vier opeenvolgende eenelektronoxidaties uitvoert',
        'Een kopercluster analoog aan die in cytochroomoxidase',
        'Een mangaancluster die vier oxidatieve equivalenten in één enkele stap opslaat',
      ],
      0,
      'De S-toestandscyclus staat vast en de S3-naar-S0-chemie niet, en dat is precies wat kunstmatige fotosynthese moet nabouwen.',
    ],
    [
      'Wat verandert een "machine-learned interatomic potential" aan simulatiepraktijk?',
      [
        'Bijna-DFT-nauwkeurigheid tegen de kosten van een krachtveld',
        'Exacte oplossing van het elektronische-structuurprobleem voor willekeurige systemen',
        'Het wegvallen van elke behoefte aan kwantummechanische referentiedata',
        'Overdraagbaarheid gegarandeerd over chemieën heen, door constructie',
      ],
      0,
      'Extrapolatie is het faalmechanisme, en het faalt stilletjes - wat verklaart waarom actief leren en onzekerheidsschatting deel zijn van de methode en geen extraatje.',
    ],
    [
      'Wat is de betekenis van "niet-klassieke" carbokationen, en waarom duurde de discussie zo lang?',
      [
        'Of het 2-norbornylkation één gedelokaliseerde soort is of snel evenwichtige klassieke ionen - kristallografisch beslecht in 2013',
        'Of carbokationen überhaupt als discrete intermediairen bestaan, of alleen als overgangstoestanden op een continue coördinaat zonder eindige levensduur',
        'Of hyperconjugatie bijdraagt aan de stabiliteit van carbokationen',
        'Of carbokationen waarneembaar zijn met NMR in superzure media',
      ],
      0,
      'Winstein tegen Brown, decennialang. Röntgenkristallografie bij lage temperatuur beëindigde het in het voordeel van de symmetrische, gedelokaliseerde structuur.',
    ],
  ],
};

export const MORE_BIOLOGY: CategoryContent = {
  msc: [
    [
      'Wat detecteert een Southern blot?',
      [
        'Specifieke DNA-sequenties, door hybridisatie met een gelabelde probe na overbrenging naar een membraan',
        'Specifieke RNA-transcripten, via dezelfde hybridisatiebenadering',
        'Specifieke eiwitten, met antilichaamdetectie na scheiding door polyacrylamide-gelelektroforese',
        'DNA-eiwitinteracties in intact chromatine',
      ],
      0,
      'RNA is Northern, eiwit is Western. Southern is de enige die naar een persoon vernoemd is, wat het standaardezelsbruggetje is.',
    ],
    [
      'Wat is de functie van een signaalpeptide?',
      [
        'Een naontstane polypeptide naar het endoplasmatisch reticulum leiden voor translocatie',
        'Een rijp eiwit markeren voor afbraak door het proteasoom',
        'Een membraaneiwit verankeren in de lipide bilaag',
        'Chaperones werven naar een ongevouwen cytosolisch eiwit',
      ],
      0,
      'Meestal afgeknipt na translocatie. De afbraaktag is ubiquitine, en het ankerdeel is een transmembraandomein.',
    ],
    [
      'Wat betekent de term "penetrantie" in de genetica?',
      [
        'Het aandeel individuen met een genotype dat het bijbehorende fenotype vertoont',
        'De ernst van het fenotype bij een aangedaan individu',
        'Het aandeel nakomelingen dat een allel van een drager erft',
        'De frequentie van een allel in een populatie in evenwicht',
      ],
      0,
      'Ernst is expressiviteit, de term waarmee penetrantie het vaakst verward wordt.',
    ],
    [
      'Wat onderscheidt apoptose van necrose?',
      [
        'Apoptose is gereguleerd en niet-inflammatoir; necrose omvat membraanbreuk en ontsteking',
        'Apoptose komt alleen voor tijdens ontwikkeling en necrose alleen bij ziekte',
        'Apoptose vereist caspase-activiteit en necrose uitsluitend lysosomale enzymen',
        'Apoptose treft afzonderlijke cellen en necrose altijd hele weefsels',
      ],
      0,
      'Gereguleerde necrotische paden - necroptose, pyroptose - hebben de nette tweedeling sindsdien flink vervaagd.',
    ],
    [
      'Wat is de rol van telomerase?',
      [
        'Chromosoomeinden verlengen om het verlies tijdens replicatie van de achterblijvende streng te compenseren',
        'Dubbelstrengsbreuken herstellen door homologe recombinatie',
        'Superhelices verwijderen voor de oprukkende replicatievork, zodat de helix verder ontrold kan worden',
        'Nieuw gesynthetiseerd DNA controleren op mismatches',
      ],
      0,
      'De reactivering ervan in de meeste kankers is waarom het een therapeutisch doelwit is, en de afwezigheid ervan in de meeste somatische cellen is waarom die een delingslimiet hebben.',
    ],
    [
      'Wat legt een Punnett-vierkant niet vast?',
      [
        'Koppeling, epistase en elke afwijking van onafhankelijke segregatie',
        'De dominantierelatie tussen twee allelen',
        'De verwachte genotypefrequenties in nakomelingen',
        'De segregatie van allelen tijdens de meiose',
      ],
      0,
      'Het veronderstelt onafhankelijke segregatie, precies wat gekoppelde loci schenden - en Bateson ontdekte dat voordat iemand het kon verklaren.',
    ],
    [
      'Waaruit is de bloed-hersenbarrière opgebouwd?',
      [
        'Tight junctions tussen endotheelcellen van haarvaten, ondersteund door astrocytvoetjes en pericyten',
        'Een doorlopend basaalmembraan rond de cerebrale vasculatuur',
        'Het arachnoïdmembraan dat cerebrospinaal vocht van bloed scheidt',
        'Actieve efflux-transporteurs in neuronale membranen, die vreemde stoffen weer terug de circulatie in pompen',
      ],
      0,
      'Efflux-transporteurs zijn een echte tweede verdedigingslinie, maar niet de barrière zelf, en zij zijn waarom zoveel CNS-medicijnkandidaten falen.',
    ],
    [
      'Wat betekent de term "gain of function"-mutatie?',
      [
        'Een mutatie die een genproduct nieuwe of verhoogde activiteit geeft',
        'Een mutatie die activiteit herstelt die verloren ging bij een eerdere mutatie',
        'Een duplicatie die het aantal kopieën van het gen verhoogt',
        'Een mutatie die transcriptie verhoogt zonder het eiwit te veranderen',
      ],
      0,
      'Het herstellende geval is een reversie of suppressor. De term heeft ook een apart en fel bestreden gebruik in de virologie-beleidsliteratuur.',
    ],
    [
      'Wat is de belangrijkste functie van regulatoire T-cellen?',
      [
        'Immuunresponsen onderdrukken en tolerantie voor zelf-antigenen handhaven',
        'Antigeen presenteren op MHC klasse II aan naïeve T-cellen',
        'Hoog-affiene antilichamen produceren na klasseswitch',
        'Virus-geïnfecteerde cellen doden door perforine-afgifte',
      ],
      0,
      'FOXP3 is de lijn-markering, en het verlies daarvan bij mensen leidt tot een verwoestend multi-orgaan-auto-immuunsyndroom.',
    ],
    [
      'Wat vereist allopatrische speciatie?',
      [
        'Geografische scheiding die genenstroom voorkomt terwijl divergentie zich opstapelt',
        'Divergente selectie binnen een continu kruisende populatie',
        'Polyploïdie die binnen één generatie ontstaat',
        'Assortatieve paring gedreven door één locus met groot effect',
      ],
      0,
      'Sympatrische speciatie is de tweede, en of die vaak voorkomt blijft een van de levendige discussies in het vakgebied.',
    ],
  ],
  phd: [
    [
      'Wat meet chromatine-immunoprecipitatie gevolgd door sequencing?',
      [
        'Genoombrede bezetting van een eiwit',
        'Chromatinetoegankelijkheid, uit gevoeligheid voor nuclease of transposase',
        'Driedimensionale contactfrequentie tussen verre loci',
        'Ontstane transcriptiesnelheden op elke locus',
      ],
      0,
      'Toegankelijkheid is ATAC-seq of DNase-seq, contacten zijn Hi-C, ontstane transcriptie is een van de pro-seq-familie.',
    ],
    [
      'Wat is de moleculaire basis van somatische hypermutatie in B-cellen?',
      [
        'AID-gemedieerde cytidinedeaminatie in het variabele gebied',
        'Willekeurige fouten van DNA-polymerase tijdens snelle klonale deling',
        'RAG-gemedieerde recombinatie van variabele, diversiteits- en verbindingssegmenten',
        'Retrovirale integratie in immunoglobulinloci',
      ],
      0,
      'RAG-recombinatie is de eerdere, afzonderlijke gebeurtenis die het aanvankelijke repertoire genereert; hypermutatie is waar affiniteitsrijping op draait.',
    ],
    [
      'Wat is de relatie tussen het Warburg-effect en hypoxie-induceerbare factor?',
      [
        'HIF drijft glycolytische genexpressie aan',
        'HIF is vereist voor het Warburg-effect in alle tumortypen',
        'HIF onderdrukt glycolyse en het verlies erin produceert het effect',
        'De twee zijn onafhankelijke paden zonder overlappende doelwitten',
      ],
      0,
      'Oncogene signalering via PI3K-Akt en Myc kan het fenotype opwekken zonder hypoxie, een observatie die de HIF-only-verklaring niet kan opvangen.',
    ],
    [
      'Wat beweert de "neutrale theorie" van moleculaire evolutie?',
      [
        'De meeste gefixeerde substituties zijn in feite neutraal',
        'Natuurlijke selectie speelt geen rol in moleculaire evolutie',
        'Substitutiesnelheden zijn noodzakelijkerwijs constant tussen lijnen',
        'Vrijwel alle mutaties zijn schadelijk en worden verwijderd door zuiverende selectie',
      ],
      0,
      'Kimura, 1968. Het is een nulmodel, geen ontkenning van selectie - en het als dat laatste lezen is de meest voorkomende misvatting.',
    ],
    [
      'Wat is de betekenis van de unfolded protein response?',
      [
        'Een signaalprogramma dat de ER-capaciteit uitbreidt en translatie stillegt',
        'Een cytosolisch chaperonnetwerk dat opeengehoopte eiwitten hervouwt',
        'Een ubiquitine-afhankelijk pad dat verkeerd gevouwen cytosolische eiwitten afbreekt',
        'Een autofage route die beschadigde mitochondriën opruimt',
      ],
      0,
      'PERK, ATF6 en IRE1 zijn de drie armen. De keuze tussen leven en dood die het maakt is waarom het voorkomt bij zowel secretoire kankers als neurodegeneratie.',
    ],
    [
      'Wat onthult het allelfrequentiespectrum in de populatiegenetica?',
      [
        'Demografische geschiedenis en selectie',
        'De recombinatiesnelheid langs een chromosoom',
        'De mutatiesnelheid per generatie direct',
        'De fysieke koppeling tussen geselecteerde en neutrale loci',
      ],
      0,
      'De D van Tajima en verwanten zijn samenvattingen ervan, en de moeilijkheid is dat expansie en selectie het op vergelijkbare manieren vervormen.',
    ],
    [
      'Wat maakt optogenetica mogelijk dat farmacologie niet kan?',
      [
        'Milliseconde-, celtype-specifieke controle van activiteit in gedefinieerde populaties in een gedragend dier',
        'Permanente uitschakeling van een neuronenpopulatie zonder chirurgie',
        'Gelijktijdige registratie van elk neuron in een circuit, met enkele-spike-resolutie in een gedragend dier',
        'Manipulatie van genexpressie zonder genetische modificatie',
      ],
      0,
      'Temporele precisie plus genetische targeting is de combinatie. Dit heropende causale circuitvragen die correlationele registratie niet kon beslechten.',
    ],
    [
      'Wat is het huidige begrip van de causale rol van het microbioom in het gastheerfenotype?',
      [
        'Associaties zijn talrijk; causale demonstraties berusten vooral op gnotobiotische transfer-experimenten met beperkte generaliseerbaarheid',
        'De meeste gerapporteerde associaties zijn causaal aangetoond via fecale transplantatie bij mensen',
        'Nu is bekend dat het microbioom geen causale rol heeft in metabole fenotypes',
        'Causaliteit is vastgesteld voor immuunontwikkeling maar nergens anders, en alleen in kiemvrije knaagdiermodellen, niet bij mensen',
      ],
      0,
      'De reproduceerbaarheidsproblemen hier zijn ernstig en vooral methodologisch - batcheffecten, compositionele data en kleine steekproefgroottes.',
    ],
    [
      'Wat beschrijft de term "haploïnsufficiëntie"?',
      [
        'Eén functionele kopie van een gen is onvoldoende voor een normaal fenotype',
        'Een dominant-negatief product dat het wildtype-eiwit hindert',
        'Het verlies van beide kopieën van een tumorsuppressor',
        'Imprinting die één ouderlijk allel tot zwijgen brengt',
      ],
      0,
      'Dit verklaart waarom sommige functieverliesmutaties dominant zijn, en het is een apart mechanisme dan een dominant-negatieve interactie.',
    ],
    [
      'Wat is het mechanisme van CRISPR-base-editing, in tegenstelling tot nuclease-editing?',
      [
        'Een katalytisch verzwakte Cas gefuseerd met een deaminase, die een base chemisch omzet zonder dubbelstrengsbreuk',
        'Een Cas-nuclease die een breuk maakt die herstelt met een aangeleverde enkelstrengsjabloon',
        'Een reverse transcriptase die nieuwe sequentie schrijft vanuit een verlengd guide-RNA',
        'Een paar zinkvinger-nucleasen dat een gerichte deletie invoert, daarna herstelt via non-homologous end joining',
      ],
      0,
      'De reverse-transcriptase-versie is prime editing, en het vermijden van de dubbelstrengsbreuk is wat het risico op indels en translocaties verlaagt.',
    ],
  ],
  professor: [
    [
      'Wat is het probleem van de "ontbrekende erfelijkheid", en wat loste het grotendeels op?',
      [
        'GWAS-hits verklaarden weinig van de erfelijkheid uit tweelingstudies; genoombrede benaderingen toonden dat veel ervan in vele kleine, veelvoorkomende effecten zit',
        'Tweelingstudies bleken systematisch vertekend en hun schattingen werden ingetrokken',
        'De erfelijkheid bleek vrijwel volledig te zitten in zeldzame varianten met groot effect',
        'Het werd opgelost door de ontdekking dat de meeste complexe eigenschappen niet erfelijk zijn zodra gedeelde omgeving en assortatieve paring gecontroleerd worden',
      ],
      0,
      'Het GREML-werk van Yang et al. verschoof de rekening aanzienlijk. Zeldzame varianten en gen-omgevinginteractie dragen bij, maar bleken niet het antwoord.',
    ],
    [
      'Wat stelt het "omnigene" model voor?',
      [
        'Bijna alle tot expressie gebrachte genen beïnvloeden complexe eigenschappen via onderling verbonden regulatoire netwerken, via perifere in plaats van kerngenen',
        'Elk gen heeft een direct causaal effect op elke eigenschap, waardoor associatiestudies noodzakelijkerwijs het hele genoom terugvinden bij voldoende grote steekproef',
        'Complexe eigenschappen worden gedreven door een klein aantal kerngenen met grote effecten',
        'Regulatoire varianten doen ertoe en coderende varianten niet',
      ],
      0,
      'Boyle, Li en Pritchard, 2017. Het onderscheid tussen kern en periferie is het deel dat critici zeggen niet geoperationaliseerd is.',
    ],
    [
      'Wat is de huidige status van de "endosymbiotische" verklaring van de mitochondriale oorsprong?',
      [
        'Stevig vastgesteld, waarbij de identiteit van de gastheerlijn en de volgorde van gebeurtenissen nog actief herzien worden',
        'Vastgesteld, inclusief de identiteit van de archaeale gastheer en de timing',
        'Betwist, waarbij autogene oorsprong nog een gangbaar alternatief is',
        'Vastgesteld voor chloroplasten maar niet voor mitochondriën, waarvan de bacteriële verwantschap nog volledig omstreden is',
      ],
      0,
      'Asgard-archaea hertekenden de gastheervraag aanzienlijk, en of mitochondriën voor of na eukaryogenese ontstonden is werkelijk open.',
    ],
    [
      'Welk probleem veroorzaakt "verzadiging van fylogenetisch signaal" bij inferentie over diepe tijd?',
      [
        'Meervoudige substituties op hetzelfde punt wissen historische informatie uit, wat artefacten zoals long-branch attraction oplevert',
        'Onvoldoende taxonbemonstering laat takken in principe onoplosbaar',
        'Snelheidsvariatie tussen lijnen kan helemaal niet gemodelleerd worden, waardoor elke reconstructie doorgaans een strikte moleculaire klok veronderstelt',
        'Horizontale overdracht maakt elke boomrepresentatie ongeldig',
      ],
      0,
      'Dit verklaart waarom modelkeuze steeds belangrijker wordt hoe dieper je gaat, en waarom aminozuurhercodering en site-heterogene modellen bestaan.',
    ],
    [
      'Wat beweert het concept van het "hologenoom", en waarom is het omstreden?',
      [
        'Dat gastheer en microbiota samen een selectie-eenheid vormen',
        'Dat microbiële genen fysiek geïntegreerd zijn in het genoom van de gastheer',
        'Dat het microbioom onafhankelijk van het gastheerfenotype evolueert',
        'Dat het genotype van de gastheer de microbioomsamenstelling volledig bepaalt',
      ],
      0,
      'De erfelijkheid van de partner is de kern: zonder betrouwbare verticale overdracht is selectie op het collectief theoretisch moeilijk te handhaven.',
    ],
    [
      'Wat is de betekenis van structuurvoorspelling op AlphaFold-schaal voor de moleculaire biologie?',
      [
        'Nauwkeurige modellen voor de meeste enkele domeinen, terwijl complexen, wanorde en conformatieverandering veel moeilijker blijven',
        'Het eiwitvouwingsprobleem is in alle opzichten opgelost, inclusief dynamica',
        'Experimentele structuurbepaling is nu overbodig, omdat voorspelde modellen nauwkeurig genoeg zijn voor elk vervolgdoel',
        'Het voorspelt functie direct uit sequentie zonder structurele inferentie',
      ],
      0,
      'Een voorspelde statische structuur is geen mechanisme, en de velden waar het de praktijk het snelst veranderde zijn die waar een vouwing de bottleneck was.',
    ],
    [
      'Wat beschrijft "developmental system drift"?',
      [
        'Behouden fenotypes die geproduceerd worden door uiteenlopende onderliggende ontwikkelingsmechanismen tussen lijnen',
        'Het geleidelijke verlies van ontwikkelingsplasticiteit in gedomesticeerde lijnen',
        'Willekeurige drift in de timing van ontwikkelingsgebeurtenissen tussen individuen',
        'De opstapeling van neutrale variatie in ontwikkelingsgenen',
      ],
      0,
      'Dit verklaart waarom een behouden gennetwerk geen bewijs is van een behouden mechanisme, en het compliceert elke extrapolatie vanuit modelorganismen.',
    ],
    [
      'Wat is de huidige stand van het debat "veroudering als geprogrammeerd versus schade"?',
      [
        'Geen van beide polen overleeft intact: behouden voedingsstofgevoelige paden moduleren de snelheden van grotendeels stochastische schade',
        'Veroudering is nu vastgesteld als een genetisch geprogrammeerd ontwikkelingsproces, volgens een schema dat bij de conceptie vastligt',
        'Veroudering is nu vastgesteld als puur stochastische schade zonder genetische modulatie',
        'Het debat werd opgelost door de ontdekking van één enkel meester-langlevigheidsgen',
      ],
      0,
      'Insuline/IGF-1 en mTOR zijn de modulatoren; het hallmarks-raamwerk is een poging om de interactie te ordenen, niet om de tweedeling te beslechten.',
    ],
    [
      'Waar verwijst "clonale hematopoëse van onbepaalde potentie" naar?',
      [
        'Uitgebreide bloedcelklonen met leukemie-geassocieerde mutaties zonder overduidelijke ziekte, en met zowel cardiovasculair risico als kankerrisico',
        'De normale oligoklonale structuur van het geheugen-T-celrepertoire',
        'Van donor afkomstige klonen die uitbreiden na een beenmergtransplantatie',
        'Somatisch mozaïcisme beperkt tot de germlijn, detecteerbaar bij nakomelingen maar zonder gevolgen voor het individu waarin het ontstond',
      ],
      0,
      'De cardiovasculaire associatie via inflammatoire signalering was de werkelijk verrassende bevinding, en die verbond twee literaturen die voorheen niet met elkaar spraken.',
    ],
    [
      'Wat is het belangrijkste obstakel bij het vertalen van senolytische therapieën?',
      [
        'Senescentie is heterogeen en deels heilzaam',
        'Senescente cellen kunnen door geen enkele beschikbare marker geïdentificeerd worden',
        'Geen enkele verbinding heeft aangetoond senescente cellen in enig model op te ruimen',
        'Senescente cellen stapelen zich niet op met de leeftijd in zoogdierweefsel',
      ],
      0,
      'p16 en SA-beta-gal zijn imperfecte markers, en dat senescentie een tumorsuppressief programma is, is precies wat het uitschakelen ervan delicaat maakt.',
    ],
  ],
};
